export default {"src":"/_next/static/media/gemente.af3147c6.svg","height":104,"width":200,"blurWidth":0,"blurHeight":0};